import Tools from './../components/tools';

export default class Home {
    constructor() {
        // Home

        this.scrollBtn();
        this.positionning();
    }

    scrollBtn() {
        const btn = document.querySelector('.header__scroll');
        const elt = document.querySelector('.section.introduction');

        if (btn && elt) {
            btn.addEventListener('click', () => {
                window.scrollTo({
                    top: Tools.offset(elt).top - 20,
                    left: 0,
                    behavior: 'smooth',
                });
            });
        }
    }

    positionning() {
        const elt = document.querySelector('.section.introduction');
        const header = document.querySelector('.header');
        if (elt && header) {
            let offset = 0;
            if (document.body.classList.contains('admin-bar')) {
                offset = 32;
            }
            offset += document.querySelector('.nav').offsetHeight;
            offset += header.offsetHeight;
            elt.style.marginTop = `${offset}px`;
            header.classList.add('js-position');
        }
    }
}